<template>
    <div class="h-dialogContainer">
        <div class='col-sm-4'>
          <ServerDetailLeft :detailShow="detailShow" :detailInfo="detailInfo" :buttonShow="deployFlag"></ServerDetailLeft>
        </div>
        <div class='col-sm-8'>
          <div class='h-ainfoBg'>
            <div class='h-ainfo'>
              <span class='icon hero-icon hero-icon-detailcode'></span>
              <span>{{$t('版本数量')}} {{versionNum}} {{$t('总部署次数')}} {{deployedNum}} </span>
            </div>
          </div>
          <ejs-tab ref='deployedTab' heightAdjustMode='heightAdjustMode' cssClass='tabsClass' :selectedItem="selectedItem">
            <div class="e-tab-header h-subscriber-subTabs-header">
              <div v-for="item of headers" :key="item.key">{{item.text}}</div>
            </div>
            <div class="e-content h-subscriber-subTabs-content">
              <div id='deployed'>
                <Table ref="deployedData" :qryParam="qryParam"></Table>
              </div>
              <div id='server'>
                <Table ref="serverData" :qryParam="qryParam" rowSelectedflag="true"></Table>
              </div>
            </div>
          </ejs-tab>
        </div>
    </div>
</template>

<script>
import Table from '../serverManagement/Table';
import { EventBus } from '../../../plugins/eventBus';
import ServerDetailLeft from '../ServerDetailLeft';

export default {
  name: 'ServerDetailDialog',
  components: {
    Table,
    ServerDetailLeft
  },
  data() {
    return {
      headers: [
        { text: '用户实例', iconCss: 'tabsClass', key: 'deployed' },
        { text: '所有版本', iconCss: 'tabsClass', key: 'server' },
      ],
      deployedNum: 0,
      versionNum: 0,
      selectedItem: 1,
      qryParam: {
        oamTypeCode: undefined,
        version: undefined
      }, // 查询条件---产品名称枚举值
      detailInfo: {
        serviceName: '',
        deliverType: '0',
        description: '',
        createTime: ''
      },
      deployFlag: false,
      detailShow: {
        description: true,
        deliverType: true,
        createTime: true
      }
    };
  },
  methods: {
    setQryParam(oamType, version) {
      this.qryParam.oamTypeCode = oamType;
      this.qryParam.version = version;
    },
    initTable(target) {
      this.deployedNum = target.deployedCount;
      // this.selectedItem = 1;
      // this.$refs.deployedTab.select(1);
      this.$refs.serverData.init(3);
      this.$refs.deployedData.init(2);
    },
  },
  created() {
    EventBus.$on('updateTotalNum', target => {
      this.versionNum = target.versionNum;
    });

    EventBus.$on('updateDetail', target => {
      this.detailInfo = target;
      console.log('===============', this.detailInfo);
      // deliverTypeId=0 native可以部署  1：image 2:helm
      if (this.detailInfo.deliverTypeId === 0
        || (this.detailInfo.deliverTypeId === 1 && this.detailInfo.existNum === 0)
        || (this.detailInfo.deliverTypeId === 2 && this.detailInfo.existNum === 0)) {
        this.deployFlag = true;
      } else {
        this.deployFlag = false;
      }
    });
  }
};
</script>

<style scoped>

</style>
